import React from "react";
import { useNavigate } from "react-router-dom";
import logo from "../components/assets/logo.svg";
import cbn from "../components/assets/cbn.svg";

const TermsAndConditions = () => {
  const navigate = useNavigate();

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-600">
      <div className="rounded-lg bg-white md:w-[800px] w-full border-[1px] border-gray-200 shadow-sm px-5 py-5 relative pb-10 mx-auto max-h-[90vh] overflow-y-auto">
        <div className="flex flex-col items-center text-center justify-center md:w-[95%] w-full md:mx-auto md:my-auto md:px-5">
          {/* Header */}
          <div className="self-center mb-7 flex items-center justify-between w-full">
            <button
              onClick={handleBack}
              className="text-[#161032] font-semibold hover:text-red-500 transition"
            >
              ← Back
            </button>
            <img src={logo} alt="logo" className="w-12" />
            <div className="w-16"></div>
          </div>

          {/* Content */}
          <div className="text-left w-full mb-8">
            <h1 className="text-2xl font-bold text-[#161032] mb-6 text-center">
              Terms and Conditions
            </h1>

            <div className="space-y-4 text-sm md:text-base text-gray-700 leading-relaxed">
              <section>
                <h2 className="text-lg font-bold text-[#161032] mb-4">
                  DISCLAIMER: Important Notice on Vehicle Value, Underinsurance & Average Clause
                </h2>

                <div className="space-y-4">
                  <p>
                    The vehicle value declared by you at policy inception ("the Declared Value") will form
                    the primary basis of premium calculation and claim settlement.
                  </p>

                  <p>
                    The Insured/customer hereby warrants that the Declared Value represents the full and
                    fair market value of the vehicle as at the inception date of this Policy. If the
                    declared value of your vehicle is lower than its actual market value at Policy
                    inception, the policy will be considered <span className="font-semibold">underinsured</span>.
                    For the purpose of this Policy, "Actual Market Value" at the time of policy inception
                    shall mean the replacement value of the vehicle at policy inception, taking into
                    account, age, condition, mileage, depreciation, and prevailing market conditions, as
                    reasonably determined by the Insurer or its appointed agent(s).
                  </p>

                  <p>
                    In such Instances, any claim payment for loss or damage will be subject to the
                    application of an <span className="font-semibold">'Average Clause'</span>. An Average
                    Clause implies that you will be treated as having insured only part of the vehicle's
                    value and will bear a proportion of any/every loss accordingly.
                  </p>
                </div>
              </section>

              <section>
                <h2 className="text-lg font-bold text-[#161032] mb-4">How Average Clause Works:</h2>

                <div className="bg-gray-100 p-4 rounded-lg space-y-3">
                  <div>
                    <p className="font-semibold">Example Scenario:</p>
                    <p className="mt-2">
                      If Actual Market Value of Vehicle = <span className="font-semibold">₦10,000,000</span>
                      <br />
                      & Value declared by you at policy inception = <span className="font-semibold">₦6,000,000</span>
                      <br />
                      And the repair cost after an Accident/Incident = <span className="font-semibold">₦4,000,000</span>
                    </p>
                  </div>

                  <div className="border-t border-gray-300 pt-3">
                    <p className="font-semibold mb-2">The claim payable will be calculated proportionately:</p>
                    <p className="bg-white p-3 rounded border-l-4 border-[#161032]">
                      (₦6,000,000 ÷ ₦10,000,000) × ₦4,000,000 = <span className="font-semibold">₦2,400,000</span>
                    </p>
                    <p className="mt-3 text-red-600">
                      You will bear the remaining <span className="font-semibold">₦1,600,000</span> required to
                      fully restore the vehicle.
                    </p>
                  </div>
                </div>
              </section>

              <section>
                <h2 className="text-lg font-bold text-[#161032] mb-4">Recommendation</h2>
                <p>
                  To avoid reduced claim payments, we strongly advise that you declare the correct and
                  current market value of your vehicle at policy inception. To confirm the current market
                  value of your vehicle, kindly contact our support team.
                </p>
              </section>

              <section className="bg-gray-50 p-4 rounded-lg border border-gray-200">
                <h2 className="text-lg font-bold text-[#161032] mb-4">Confirmation</h2>
                <p>By proceeding with this purchase, you confirm that:</p>
                <div className="mt-3 space-y-2">
                  <p>
                    The declared vehicle value reflects the current
                    market value, and you understand that underinsurance will result in proportionate claim
                    settlement.
                  </p>
                </div>
              </section>

              <p className="text-center text-gray-500 mt-6">Best regards,</p>
              <p className="text-center font-semibold text-[#161032]">Premium Trust Insurance</p>
            </div>
          </div>

          {/* Footer */}
          <div className="text-center mt-8 w-full border-t pt-6">
            <p className="text-[#001F54] text-sm">Powered by</p>
            <div className="flex items-center gap-1 mt-1 justify-center">
              <img className="w-4" src={logo} alt="cbn" />
              <p className="text-[#001F54] text-sm font-semibold">
                Premium<span className="text-red-500">Trust</span>Bank
              </p>
            </div>
          </div>

          <div className="flex w-full justify-center text-center items-center gap-2 mt-6 font-medium">
            <img src={cbn} alt="cbn" />
            <p className="text-[#001F54] md:text-md text-sm">
              Licensed by the Central Bank of Nigeria
            </p>
          </div>

          <button
            onClick={handleBack}
            className="bg-[#161032] h-12 font-semibold text-lg flex items-center justify-center text-white py-3 mt-6 rounded-lg hover:bg-red-500 transition ease-in-out duration-300 w-full"
          >
            Back to Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
